import { ReactElement } from 'react';
import ContactInformation from '@components/ContactInformation/ContactInformation';
import { tpContactInfoDisplayObject } from '@services/FormFieldConfig';

function TPStep4(): ReactElement {
  const currentSp = 'I do not have an email address';
  return <ContactInformation displayObject={tpContactInfoDisplayObject} currentStep={currentSp} />;
}

export default TPStep4;
